export const SET_INGREDIENTS = "ingredient/SET_INGREDIENTS"
export const SET_SETS = "sets/SET_SETS"
export const SET_PRODUCTS = "product/SET_PRODUCTS"
export const SET_IS_LOADING = "SET_IS_LOADING"
export const SET_MENU_SEARCH = "SET_MENU_SEARCH"
export const SET_MENU_CATEGORY = "SET_MENU_CATEGORY"
export const SET_MENU_PAGE = "SET_MENU_PAGE"
export const SET_SELECTED_CATEGORY = "SET_SELECTED_CATEGORY"
export const SET_UNIQUE_CATEGORIES = "SET_UNIQUE_CATEGORIES"
